import { useEffect, useState } from "react";
import { Editor } from "@tiptap/react";
import { SelectChangeEvent } from "@mui/material";

import { RevbellSelect } from "../../../components/Inputs/RevbellSelect";

type Level = 1 | 2 | 3 | 4 | 5 | 6;

const HeadingSelector = ({ editor }: { editor: Editor }) => {
  const [heading, setHeading] = useState<number | "paragraph">("paragraph");

  useEffect(() => {
    if (!editor) return;

    const updateHeading = () => {
      const levels = [1, 2, 3, 4, 5, 6];
      const currentHeading = levels.find((level) =>
        editor.isActive("heading", { level })
      );
      setHeading(currentHeading || "paragraph");
    };

    editor.on("selectionUpdate", updateHeading);
    editor.on("transaction", updateHeading);

    return () => {
      editor.off("selectionUpdate", updateHeading);
      editor.off("transaction", updateHeading);
    };
  }, [editor]);

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    const value = event.target.value;
    if (value === "paragraph") {
      editor.chain().focus().setParagraph().run();
    } else {
      editor
        .chain()
        .focus()
        .toggleHeading({ level: value as Level })
        .run();
    }
  };

  return (
    <RevbellSelect
      defaultValue={"paragraph"}
      value={heading}
      options={[
        { value: "paragraph", label: "Normal" },
        { value: 1, label: "H1" },
        { value: 2, label: "H2" },
        { value: 3, label: "H3" },
        { value: 4, label: "H4" },
        { value: 5, label: "H5" },
        { value: 6, label: "H6" },
      ]}
      onChange={handleChange}
      sx={{
        width: "100px",
        "&.MuiInputBase-root": {
          backgroundColor: "background.input",
        },
        "& .MuiSelect-select": { padding: "4px 32px 4px 15px" },
      }}
    />
  );
};

export default HeadingSelector;
